import { useEffect, useMemo } from "react";
import { useCollapse } from "react-collapsed";
import { useSessionStorage, useToggle } from "react-use";
export function usePersistentCollapse(id, executionId, initialValue) {
    const [collapsed, storeCollapsed] = useSessionStorage([executionId, "collapsed", id].filter(Boolean).join(":"), initialValue, false);
    const [isExpanded, toggleExpanded] = useToggle(!collapsed);
    const { getCollapseProps, getToggleProps } = useCollapse({
        isExpanded,
        duration: 300,
    });
    useEffect(() => {
        if (collapsed !== !isExpanded) {
            storeCollapsed(!isExpanded);
        }
    }, [collapsed, isExpanded, storeCollapsed]);
    return useMemo(() => ({
        toggleProps: getToggleProps({
            onClick: toggleExpanded,
        }),
        collapseProps: getCollapseProps(),
        collapsed,
        toggleExpanded,
    }), [getCollapseProps, getToggleProps, toggleExpanded, collapsed]);
}
